/**
 *  Tag script file
 *
 * <Tag text="text" color="#16969d"></Tag>
 * <Tag type="toggle" id="id" text="toggle" :active="true" @toggle="fn"></Tag>
 * <Tag type="toggle-close" id="id" text="toggle close" :active="false" @toggle="fn"></Tag>
**/

export default {
  name: 'Tag',
  mixins: [],
  components: {},
  props: {
    type: {
      type: String,
      default: 'info',
      required: false,
      validator (value) {
        const types = [
          'info',
          'info-rounded',
          'toggle',
          'toggle-close'
        ]
        return types.indexOf(value) !== -1
      }
    },
    id: {
      type: [String, Number],
      required: false
    },
    active: {
      type: Boolean,
      required: false
    },
    text: {
      type: [String, Number],
      required: true
    },
    color: {
      type: String,
      required: false
    },
    backgroundColor: {
      type: String,
      default: null,
      required: false
    },
    borderColor: {
      type: String,
      default: null,
      required: false
    },
    textColor: {
      type: String,
      default: null,
      required: false
    },
    tooltipText: {
      type: String,
      required: false
    },
    tooltipPosition: {
      type: String,
      default: 'top',
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    iconFill: {
      type: String,
      required: false
    },
    blocked: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isActive: this.active
    }
  },
  computed: {
    background () {
      return { 'background-color': this.color }
    }
  },
  methods: {
    toggle () {
      if (this.type === 'toggle' || this.type === 'toggle-close') {
        if (!this.blocked) {
          this.isActive = !this.isActive
        }

        if (this.id === null || this.id === undefined) {
          // eslint-disable-next-line no-console
          console.error(`[Tag] You need specify an ID`)
        } else {
          this.$emit('toggle', { id: this.id, state: this.isActive })
        }
      }
    }
  },
  watch: {
    active (state) {
      this.isActive = state
    }
  }
}
